/* Presentation only: reveal/delegate to existing native controls; never calculate or submit an order. */
(function () {
  'use strict';
  if (window.KlikProductDock) { window.KlikProductDock.init(document); return; }
  var records = [];
  var bound = new WeakSet();
  var watched = new WeakSet();
  var queued = false;
  var lastBlocked;
  var modalSelector = 'dialog[open], .drawer--is-open, .modal--is-active, .pswp--open, [role="dialog"][aria-modal="true"], #itoris_dynamicproductoptions_popup';

  function western(value) {
    return String(value || '').replace(/[\u0660-\u0669\u06f0-\u06f9]/g, function (digit) {
      var code = digit.charCodeAt(0);
      return String(code - (code >= 0x06f0 ? 0x06f0 : 0x0660));
    });
  }
  function rendered(node) {
    return !!node && !node.closest('[hidden], [inert], [aria-hidden="true"]') && node.getClientRects().length > 0 && getComputedStyle(node).visibility !== 'hidden';
  }
  function typing() {
    var node = document.activeElement;
    if (!node || !node.matches) return false;
    return node.matches('textarea, [contenteditable="true"], input:not([type="hidden"]):not([type="checkbox"]):not([type="radio"]):not([type="range"]):not([type="color"]):not([type="file"]):not([type="submit"]):not([type="button"]):not([type="reset"])');
  }
  var STUDIO_OPEN = /(^|\s)(kf-studio-open|ready-stock-open|hz-studio-open|kd-studio-open|klik-studio-open|modal-open)(\s|$)/;
  function isBlocked() {
    var classes = document.documentElement.classList;
    if (document.querySelector('dialog.kd-opening[open]')) return true;
    // an open studio (the same root classes the WhatsApp bubble reads) short-circuits before the dialog scan, which
    // forces a layout while the studio builds its DOM (CFG-1023: 45 ms per sofa-set open)
    if (STUDIO_OPEN.test(document.documentElement.className) || STUDIO_OPEN.test(document.body.className)) return true;
    if (document.fullscreenElement || typing() || classes.contains('klik-dpo-builder-active') || classes.contains('kf-studio-open') || classes.contains('sofa-fixed-open') || classes.contains('js-drawer-open') || classes.contains('js-modal-open')) return true;
    if (Array.prototype.some.call(document.querySelectorAll(modalSelector), rendered)) return true;
    return Array.prototype.some.call(document.querySelectorAll('[data-klik-dpo-wizard].is-builder-started'), rendered);
  }
  function getForm(record) { return record.section.querySelector('form.product-single__form'); }
  function mainAction(record) {
    var section = record.section;
    var entry = Array.prototype.find.call(section.querySelectorAll('[data-ready-open]:not([data-ready-quick]), [data-furniture-open], [data-sofa-fixed-open], [data-klik-start-builder]'), rendered);
    if (entry) return entry;
    var form = getForm(record);
    var wizard = section.querySelector('[data-klik-dpo-wizard]');
    var step = Number(section.getAttribute('data-klik-dpo-step') || 0);
    var last = wizard ? Number(wizard.dataset.stepCount || 4) : 4;
    if (record.type !== 'ready') {
      if (wizard && step === 0) return section.querySelector('[data-klik-start-builder]');
      if (wizard && step > 0 && step < last) return section.querySelector('[data-klik-step-continue]');
      if (!wizard) {
        var start = section.querySelector('[data-furniture-open], [data-sofa-fixed-open]');
        if (start) return start;
      }
    }
    return form && (form.querySelector('[dpo_add2cart]') || form.querySelector('[data-add-to-cart]') || form.querySelector('[type="submit"]'));
  }
  function updateCopy(record) {
    var state = record.state || {};
    var ar = record.ar;
    var text = record.type === 'ready' ? (ar ? 'اختر الخيارات' : 'Choose options') : record.type === 'quote' ? (ar ? 'اطلب عرض سعر' : 'Request a quote') : (ar ? 'فصّل على ذوقك' : 'Customize');
    if (Number(state.step) > 0 && record.type === 'custom') {
      var last = Number((record.section.querySelector('[data-klik-dpo-wizard]') || {dataset: {}}).dataset.stepCount || 4);
      text = Number(state.step) >= last ? (state.quoteRequired ? (ar ? 'راجع عرض السعر' : 'Review quote') : (ar ? 'راجع اختياراتك' : 'Review your choices')) : (ar ? 'تابع التصميم' : 'Continue design');
    }
    if (record.label.textContent !== text) record.label.textContent = text;
    record.bar.dataset.dockStep = String(Number(state.step) || 0);
  }
  function update() {
    queued = false;
    records = records.filter(function (record) { return record.bar.isConnected && record.section.isConnected; });
    var blocked = isBlocked();
    var whatsapp = document.getElementById('KlikWhatsApp');
    if (whatsapp && whatsapp.hidden !== blocked) whatsapp.hidden = blocked;
    if (lastBlocked !== blocked) {
      lastBlocked = blocked;
      document.dispatchEvent(new CustomEvent('klik:dock-blocking', {detail: {blocked: blocked}}));
    }
    // Shared WhatsApp blocking must remain current after a quickview/section removes its dock.
    if (!records.length) return;
    // No page position is needed while a studio/modal owns the screen, or
    // on desktop where this mobile dock is never shown. Avoid forced layout
    // while native configuration fields are being prepared or updated.
    if (blocked || window.innerWidth > 749) {
      records.forEach(function(record){if(!record.bar.hidden)record.bar.hidden=true;});
      return;
    }
    var header = document.getElementById('KlikHeader');
    var top = header ? Math.max(0, header.getBoundingClientRect().bottom) : 0;
    var footer = document.querySelector('footer.ko-footer, footer.site-footer');
    var atFooter = rendered(footer) && footer.getBoundingClientRect().top < window.innerHeight;
    records.forEach(function (record) {
      var action = mainAction(record);
      var hide = blocked || atFooter || window.innerWidth > 749 || !rendered(action) || action.disabled || action.getAttribute('aria-disabled') === 'true';
      if (!hide) {
        var box = action.getBoundingClientRect();
        // A CTA below the fold is not a reason to show a second CTA. It must have passed above.
        // Keep the return route available through the product's materials, reviews and delivery guide.
        hide = box.bottom > top;
      }
      // Scrolling usually leaves visibility unchanged; avoid an attribute mutation per frame.
      if (record.bar.hidden !== !!hide) record.bar.hidden = !!hide;
    });
  }
  function schedule() {
    if (!queued) { queued = true; requestAnimationFrame(update); }
  }
  function reveal(record, action) {
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var disclosure = record.section.querySelector('[data-kpx-fabric-disclosure]');
    var target = record.type === 'ready' && disclosure ? disclosure.querySelector('summary') : action;
    if (record.type === 'ready' && disclosure) disclosure.open = true;
    target.scrollIntoView({behavior: reduced ? 'auto' : 'smooth', block: 'center'});
    target.focus({preventScroll: true});
  }
  function activate(record) {
    var action = mainAction(record);
    if (isBlocked() || !rendered(action) || action.disabled || action.getAttribute('aria-disabled') === 'true') { schedule(); return; }
    var entry = action.matches('[data-ready-open], [data-klik-start-builder], [data-furniture-open], [data-sofa-fixed-open]');
    if (entry) {
      // Let the native controller open and focus its own options/review dialog.
      action.click();
    } else {
      // A return-to-product action never submits the native order form.
      reveal(record, action);
    }
    schedule();
  }
  function init(scope) {
    scope.querySelectorAll('[data-klik-product-dock]').forEach(function (bar) {
      if (bound.has(bar)) return;
      var section = document.getElementById(bar.dataset.klikSection);
      var button = bar.querySelector('[data-klik-dock-action]');
      var label = bar.querySelector('[data-klik-sticky-cta]');
      if (!section || !button || !label) return;
      bound.add(bar);
      var record = {bar: bar, section: section, button: button, label: label, type: bar.dataset.actionType || 'custom', ar: /^ar(?:-|$)/i.test(document.documentElement.lang || '') || bar.dataset.isArabic === 'true'};
      var title = bar.querySelector('[data-klik-dock-title]');
      if (title) title.textContent = western(title.textContent);
      bar.dir = record.ar ? 'rtl' : 'ltr';
      records.push(record);
      button.addEventListener('click', function () { activate(record); });
      updateCopy(record);
    });
    watchDialogs();
    schedule();
  }
  /* wave1 pdp SP-02 (2026-10-27): on the product pages run by the klik-pdp.js layer ([data-kpd-page], the room shop) the
     page's one sticky bar is aside.kpdp-bar. This dock never showed there (mainAction() finds no rendered target), yet
     update() measured the header, the footer and the call to action on every scroll frame and state change (0.1-0.7 s of
     forced layout per load at CPU x4, LoAF). There it stays hidden and registers nothing; hiding the WhatsApp bubble while
     a studio or dialog is open is assets/klik-whatsapp.js's own job (it now reads the studio states this dock read).
     Other pages (the custom-quote product) keep the dock exactly as before. */
  if (document.querySelector('[data-kpd-page], #kl-room-shop')) {
    document.querySelectorAll('[data-klik-product-dock]').forEach(function (bar) { if (!bar.hidden) bar.hidden = true; });
    window.KlikProductDock = {init: function () {}, schedule: function () {}, isBlocked: isBlocked, off: true};
    return;
  }
  var stateObserver = new MutationObserver(schedule);
  stateObserver.observe(document.documentElement, {attributes: true, attributeFilter: ['class']});
  stateObserver.observe(document.body, {attributes: true, attributeFilter: ['class']});
  function watchDialogs() {
    document.querySelectorAll('dialog, [role="dialog"], .drawer, .modal, .pswp, #itoris_dynamicproductoptions_popup').forEach(function (node) {
      if (watched.has(node)) return;
      watched.add(node);
      stateObserver.observe(node, {attributes: true, attributeFilter: ['open', 'class', 'hidden', 'aria-hidden', 'aria-modal', 'style']});
    });
  }
  // Direct body insertions catch late native dialogs without observing the DPO option subtree.
  new MutationObserver(function () { watchDialogs(); schedule(); }).observe(document.body, {childList: true});
  window.KlikProductDock = {init: init, schedule: schedule, isBlocked: isBlocked};
  window.addEventListener('scroll', schedule, {passive: true});
  window.addEventListener('resize', schedule, {passive: true});
  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', schedule, {passive: true});
    window.visualViewport.addEventListener('scroll', schedule, {passive: true});
  }
  ['click', 'change', 'focusin', 'focusout', 'toggle', 'fullscreenchange', 'cart:updated'].forEach(function (name) { document.addEventListener(name, schedule, true); });
  document.addEventListener('klik:dpo-state', function (event) {
    var state = event.detail || {};
    records.forEach(function (record) {
      if (String(state.productId) !== String(record.bar.dataset.productId)) return;
      record.state = state;
      updateCopy(record);
    });
    schedule();
  });
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('quickview:loaded', function () { init(document); });
  init(document);
})();
